import React, { useEffect, useState } from "react";
import {
  useEditDataSourceMutation,
  useEditMeetingMutation,
} from "../EditDataSources/EditDataSourceSlice";

export default function EditMeeting({ meetingObject, setTabValue }) {
  const getISTDateTimeParts = () => {
    const now = new Date();
    const istOffset = 5.5 * 60; // IST in minutes
    const localOffset = now.getTimezoneOffset(); // Local timezone offset in minutes
    const istTime = new Date(now.getTime() + (istOffset + localOffset) * 60000);

    const pad = (num) => String(num).padStart(2, "0");

    const year = istTime.getFullYear();
    const month = pad(istTime.getMonth() + 1);
    const date = pad(istTime.getDate());
    const hours = pad(istTime.getHours());
    const minutes = pad(istTime.getMinutes());
    const seconds = pad(istTime.getSeconds());

    return {
      dateOfCheckOutDate: `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`,
      checkOutTime: `${hours}:${minutes}:${seconds}`,
    };
  };

  const { checkOutTime } = getISTDateTimeParts();

  console.log(meetingObject);
  const [form, setForm] = useState(
    meetingObject && {
      meetingCategory: meetingObject.Meeting_category,
      username: meetingObject.Owner_Name,
      whomToVisit: meetingObject.Whom_To_Visit,
      dateOfCheckInDate: meetingObject.Day_of_check_in_date,
      checkInTime: meetingObject.check_in_time,
      checkOutTime: checkOutTime,
      accountName: meetingObject.Account_Name,
      subject: meetingObject.Subject,
      remarks: "",
    }
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };
  const [editMeeting, { data, isError, error, isLoading, isSuccess }] =
    useEditMeetingMutation();
  if (isLoading) {
    console.log("loading");
  }
  if (isError) {
    console.log(error);
  }
  if (isSuccess) {
    console.log(data);
  }
  
  useEffect(() => {
    if (data && data["message"]) {
      const timer = setTimeout(() => {
        setTabValue("all");
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const {
      meetingCategory,
      username,
      whomToVisit,
      checkInTime,
      subject,
      dateOfCheckInDate,
      accountName,
      remarks,
    } = form;
    // console.log("Form Submitted:", form);
    const object = {
      databaseID: "67f8d94fd87ed27dc5b2b305",
      data: [
        {
          Meeting_category: meetingCategory,
          Owner_Name: username,
          Whom_To_Visit: whomToVisit,
          check_in_time: checkInTime,
          check_out_time: checkOutTime,
          Day_of_check_in_date: dateOfCheckInDate,
          Account_Name: accountName,
          Subject: subject,
          Remarks: remarks,
        },
      ],
    };
    console.log(object);
    editMeeting(object);
  };
  return (
    <section className="w-full h-[94vh] flex items-center justify-center ">
      <form
        onSubmit={handleSubmit}
        className="sm:w-full md:w-[35%] h-full flex flex-col gap-4 items-center justify-center"
      >
        <div className="flex flex-col w-full items-start gap-2">
          <label htmlFor="meetingCategory" className="font-medium">
            Meeting Category
          </label>
          <input
            type="text"
            name="username"
            value={form.meetingCategory}
            readOnly
            required
            placeholder="user123"
            className="border rounded w-full p-[0.2rem] focus:outline-none"
          />
        </div>

        <div className="flex flex-col w-full items-start gap-2">
          <label htmlFor="username" className="font-medium">
            Username
          </label>
          <input
            type="text"
            name="username"
            value={form.username}
            readOnly
            required
            placeholder="user123"
            className="border rounded w-full p-[0.2rem] focus:outline-none"
          />
        </div>

        <div className="flex flex-col w-full items-start gap-2">
          <label htmlFor="whomToVisit" className="font-medium">
            Whom to Visit
          </label>
          <input
            type="text"
            name="whomToVisit"
            value={form.whomToVisit}
            readOnly
            placeholder="John Doe"
            className="border rounded w-full p-[0.2rem] focus:outline-none"
          />
        </div>

        <div className="flex flex-col w-full items-start gap-2">
          <label htmlFor="checkInTime" className="font-medium">
            Check-In Time
          </label>
          <input
            type="text"
            name="checkInTime"
            value={form.checkInTime}
            required
            readOnly
            className="border rounded w-full p-[0.2rem] focus:outline-none"
          />
        </div>

        <div className="flex flex-col w-full items-start gap-2">
          <label htmlFor="subject" className="font-medium">
            Subject
          </label>
          <input
            type="text"
            name="subject"
            value={form.subject}
            placeholder="Meeting Subject"
            className="border rounded w-full p-[0.2rem] focus:outline-none"
          />
        </div>
        <div className="flex flex-col w-full items-start gap-2">
          <label htmlFor="subject" className="font-medium">
            Account Name
          </label>
          <input
            type="text"
            name="accountName"
            value={form.accountName}
            readOnly
            required
            placeholder="Harry Potter"
            className="border rounded w-full p-[0.2rem] focus:outline-none"
          />
        </div>
        <div className="flex flex-col w-full items-start gap-2">
          <label htmlFor="notes" className="font-medium">
            Notes
          </label>
          <textarea
            name="remarks"
            value={form.remarks}
            onChange={handleChange} // assuming you have a change handler
            placeholder="Write any remaks here..."
            rows={3}
            required
            className="border rounded w-full p-[0.2rem] focus:outline-none resize-none"
          />
        </div>

        <div className="flex items-center w-full justify-end gap-2">
          {isError ? (
            <span className="text-red-500 font-medium">
              {error["data"]["message"]}
            </span>
          ) : null}
          {data !== undefined ? (
            <span className="text-green-500 font-medium">
              {data["message"]}
            </span>
          ) : null}
          <button
            type="submit"
            className="bg-blue-950 text-white rounded px-4 py-1"
          >
            {isLoading ? "Updating" : "Update"}
          </button>
        </div>
      </form>
    </section>
  );
}
